module.exports = __webpack_public_path__ + "static/media/landingTile1.7a52da3f.png";